module.exports = __webpack_public_path__ + "img/shape-3-mobile@2x.baff7866.png";